module.exports = __webpack_public_path__ + "img/cover-redeem-bg-mobile.e8da5fe5.png";